import { useState, useEffect } from "react";
import { Flex } from "@aws-amplify/ui-react";

import {
    CommonTitle,
} from './ui-components';

import {
    HeaderWrapper,
    KanshiLocationWrapper,
    KanshiLogAreaWrapper,
    KanshiFrameSummaryWrapper,
    CommonBtnRoundWrapper,
} from './componentsWrapper';

import {
    getDisplaySettingJson
} from './lib/SettingUtil';

import { TAB_ALL } from "./lib/ConstList";

import { DEFAULT_DISPLAY_SETTING } from "./lib/ConstList";

const KanshiMain = () => {
    // 現在選択中のタブ名
    const [selectedLocation, setSelectedLocation] = useState(TAB_ALL);

    // 表示ラベル設定
    const [displaySettingJson, setDisplaySettingJson] = useState(DEFAULT_DISPLAY_SETTING);

    // マスクされたログを表示・非表示フラグ
    const [isMaskedLogVisible, setIsMaskedLogVisible] = useState(false);

    const initDisplaySettingJson = async () => {
        const displaySettingJson = await getDisplaySettingJson();
        if (displaySettingJson !== null) {
            setDisplaySettingJson(displaySettingJson);
        } else {
            console.log("displaySettingJson is null");
        }
    }

    const onClickMaskLog = () => {
        // マスクされたログを表示・非表示ボタン
        setIsMaskedLogVisible(!isMaskedLogVisible);
    }

    useEffect(() => {
        // console.log("KanshiMain");
        // console.log("process.env.REACT_APP_TEST: ",process.env.REACT_APP_TEST)
        // console.log("process.env.REACT_APP_LOCATION_NAME: ",process.env.REACT_APP_LOCATION_NAME)
        // console.log("isLocalMode: ",isLocalMode)
        // 表示設定取得
        initDisplaySettingJson();
    }, []);

    return (
        <div
            style={{
                height: '100vh',
                display: "flex",
                flexFlow: "column"
            }}
        >
            <HeaderWrapper
            />
            <Flex
                gap="40px"
                direction="row"
                // width="1872px"
                marginLeft={"24px"}
                marginRight={"24px"}
                height="100%"
                justifyContent="space-between"
                alignItems="flex-start"
                position="relative"
                padding="0px 0px 0px 0px"
            // {...rest}
            // // {...getOverrideProps(overrides, "LayoutTougoukanshiAll")}
            >
                <Flex
                    gap="24px"
                    direction="column"
                    width="unset"
                    height="100%"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                // // {...getOverrideProps(overrides, "Frame 866")}
                >
                    <CommonTitle
                        width="240px"
                        height="18px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        shrink="0"
                        position="relative"
                        padding="0px 0px 0px 0px"
                        size="large"
                        overrides={{
                            text: {
                                children: "統合監視",
                            }
                        }}
                    // // {...getOverrideProps(overrides, "Common/Title500220679")}
                    ></CommonTitle>
                    <Flex
                        gap="0"
                        direction="column"
                        width="unset"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        shrink="0"
                        position="relative"
                        paddingBottom={"24px"}
                        style={{
                            flexGrow: 1,
                        }}
                    // // {...getOverrideProps(overrides, "Kyoten")}
                    >
                        {displaySettingJson !== null && (
                            <KanshiLocationWrapper
                                display="flex"
                                gap="8px"
                                direction="row"
                                width="unset"
                                height="unset"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                                shrink="0"
                                position="relative"
                                padding="0px 0px 0px 0px"
                                displaySettingJson={displaySettingJson}
                                selectedLocation={selectedLocation}
                                setSelectedLocation={setSelectedLocation}
                            // situation="全拠点"
                            // // {...getOverrideProps(overrides, "Kanshi/Location")}
                            ></KanshiLocationWrapper>
                        )}
                    </Flex>
                </Flex>
                <Flex
                    gap="12px"
                    direction="column"
                    width="unset"
                    height="100%"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    style={{
                        flexGrow: 1,
                    }}
                // {...getOverrideProps(overrides, "Frame 865")}
                >
                    <Flex
                        direction="row"
                        width="unset"
                        height="unset"
                        justifyContent="space-between"
                        alignItems="flex-start"
                        shrink="0"
                        alignSelf="stretch"
                        position="relative"
                        padding="0px 0px 0px 0px"
                    // {...getOverrideProps(overrides, "Frame 864")}
                    >
                        <CommonTitle
                            width="240px"
                            height="18px"
                            display="block"
                            gap="unset"
                            alignItems="unset"
                            justifyContent="unset"
                            shrink="0"
                            position="relative"
                            padding="0px 0px 0px 0px"
                            size="large"
                            overrides={{
                                text: {
                                    children: "監視ログ",
                                }
                            }}
                        // {...getOverrideProps(overrides, "Common/Title500220741")}
                        ></CommonTitle>

                        <Flex>
                            {/* マスクされたログを表示・非表示ボタン */}
                            <CommonBtnRoundWrapper
                                color="Gray"
                                children={isMaskedLogVisible ? "マスク帯域ログ　表示中" : "マスク帯域ログ　非表示中"}
                                onClick={onClickMaskLog}
                            />

                            {/* 定期レポート出力 */}
                            <KanshiFrameSummaryWrapper
                                displaySettingJson={displaySettingJson}
                            />
                        </Flex>
                    </Flex>

                    {displaySettingJson !== null && (
                        <KanshiLogAreaWrapper
                            isMaskedLogVisible={isMaskedLogVisible}
                            displaySettingJson={displaySettingJson}
                            selectedLocation={selectedLocation}
                        >
                        </KanshiLogAreaWrapper>
                    )}
                </Flex>
            </Flex>
        </div>
    );

}

export default KanshiMain;